export { SectionDateHeader } from '@/components/molecules/section-header/SectionDateHeader';
export type { SectionDateHeaderProps } from '@/components/molecules/section-header/SectionDateHeader';
